export default __webpack_public_path__ + "static/media/volunteer4.ea0389e2.png";